import { Card } from "~/screens/Hub/Home/components";
import { BOOK_VISIT } from "~/screens/Hub/shared/sharedUrls";
import { customIcons } from "~/ui";

export const InsuranceCoverage = () => (
  <Card title="Insurance coverage" className="items-start space-y-4">
    <div className="w-full space-y-3 text-left">
      <a
        href={BOOK_VISIT}
        target="_blank"
        rel="noopener noreferrer"
        className="text-violet inline-flex items-center gap-1 font-medium hover:underline"
      >
        Find out if you're covered
        <customIcons.ArrowRight className="fill-2 size-4" />
      </a>

      <p className="text-gray-700">
        Or text us a photo of the front and back of your insurance card along
        with your date of birth, and we'll confirm within 2 business days.
      </p>

      <div className="flex items-center gap-1">
        <customIcons.Message className="text-violet" aria-hidden="true" />
        <span className="text-indigo">Insurance Verification Textline:</span>
        <a
          href="tel:4148886578"
          className="text-violet font-medium hover:underline"
        >
          (414) 888-6578
        </a>
      </div>
    </div>
  </Card>
);
